// extracted by mini-css-extract-plugin
module.exports = {"opportunityWrapper":"_f28e7ec","showMoreWrapper":"_64a13c8","invalidCombinationsMessage":"_f8af518","hidden":"_9698992"};